module.exports = __webpack_public_path__ + "img/drug-dog.3d18091e.png";